import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BottomSheetContext = createContext();

export const useBottomSheet = () => {
  const context = useContext(BottomSheetContext);
  if (!context) {
    throw new Error('useBottomSheet must be used within BottomSheetProvider');
  }
  return context;
};

export const BottomSheetProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState('');
  const [height, setHeight] = useState('auto');
  const [headerColor, setHeaderColor] = useState('green');
  const [onCloseCallback, setOnCloseCallback] = useState(null);
  const location = useLocation();

  const openBottomSheet = ({ content: sheetContent, title: sheetTitle = '', height: sheetHeight = 'auto', headerColor: sheetHeaderColor = 'green', onClose }) => {
    setContent(sheetContent);
    setTitle(sheetTitle);
    setHeight(sheetHeight);
    setHeaderColor(sheetHeaderColor);
    setOnCloseCallback(() => onClose);
    setIsOpen(true);
    // ページの一番上にスクロール
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const closeBottomSheet = () => {
    setIsOpen(false);
    if (onCloseCallback) {
      onCloseCallback();
    }
    setTimeout(() => {
      setContent(null);
      setTitle('');
      setHeight('auto');
      setHeaderColor('green');
      setOnCloseCallback(null);
    }, 300);
  };

  // ルート変更時にBottomSheetを自動的に閉じる
  // ただし、需要詳細→商品詳細の遷移は除外
  useEffect(() => {
    if (isOpen) {
      const isStoreItemNavigation = location.pathname.match(/^\/stores\/\d+\/items\/\d+$/);
      if (!isStoreItemNavigation) {
        closeBottomSheet();
      }
    }
  }, [location.pathname]);

  return (
    <BottomSheetContext.Provider
      value={{
        isOpen,
        content,
        title,
        height,
        headerColor,
        openBottomSheet,
        closeBottomSheet,
      }}
    >
      {children}
    </BottomSheetContext.Provider>
  );
};
